import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mx-auto p-5" }

import Logo from './components/utils/Logo.vue';
import Navbar from './components/utils/Navbar.vue';




export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Navbar),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_view)
    ])
  ]))
}
}

})